"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS_PER_YEAR = exports.FINDER = void 0;
exports.FINDER = 'https://finder.terra.money';
exports.BLOCKS_PER_YEAR = 4656810;
//# sourceMappingURL=index.js.map